import store from '../../../store'

const searchParams = () => {
  return store.getters.GET_SEARCH_PARAMS
}

const newSearchParams = () => {
  return store.getters.GET_NEW_SEARCH_PARAMS
}

const currentPage = () => {
  return store.getters.GET_CURRENT_PAGE
}

const totalPagesNum = () => {
  return store.getters.GET_TOTAL_PAGES_NUM
}

export {
  searchParams,
  newSearchParams,
  currentPage,
  totalPagesNum
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/searchStore-getters.js